import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { MultipleSelect, SelectOption } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const DataSourceTypeField = () => {
  const { data: dataSourceTypeOptions, isFetching } = useGetDatasetEnumsQuery({
    enumKey: DatasetCreationEnum.DATA_TYPE,
  });
  const { hasLockedStatus } = useHasLockedStatus();

  const selectOptions: SelectOption[] =
    dataSourceTypeOptions?.map(({ value }) => ({
      value,
      label: value.replace(/_/g, ' '),
    })) || [];

  return (
    <MultipleSelect
      name="data_format"
      required
      label="DATA SOURCE TYPE"
      options={selectOptions}
      placeholder="Select the data source type"
      disabled={hasLockedStatus || isFetching}
    />
  );
};

export default DataSourceTypeField;
